import { indexName, siteTitle } from "../opts.js";
import { router } from "./routing.js";
import { search } from './searchClient.js';
import { isSearchPage } from "./helpers.js";

export function getInstantSearchCurrentCategory() {
	const indexUiState = search.getUiState()[INSTANT_SEARCH_INDEX_NAME];
	const menuUiState = indexUiState && indexUiState.menu;
	const currentCategories =
	  menuUiState &&
	  menuUiState[attribute];

	return currentCategories && currentCategories[0];
}

export function getUrl(indexUiState) {
	return search.createURL({ [indexName]: indexUiState });
}

export const getItemWrapper = ({
	html,
	children,
	attribute,
	value,
 }) => {
	const uiState = {
		query,
		menu: {
		  [attribute]: [category],
		},
	  };

	return html`
	<a class="aa-ItemLink"
	  href=${getUrl(uiState)}
	  onClick=${(event) => {
		if (!isModifierEvent(event)) {
		  // Bypass the original link behavior if there's no event modifier
		  // to set the InstantSearch UI state without reloading the page.
		  event.preventDefault();
		}
	  }}>${children}</a>`;
}


export function getItemUrl({ query, category }) {
	return getInstantSearchUrl({
	  query,
	  menu: {
		[attribute]: [category],
	  },
	});
}

export const onSelect = ({
	setIsOpen,
	setQuery,
	event,
	query,
	category
}) => {
	if (isModifierEvent(event)) {
		return;
	}

	setQuery(query);
	setIsOpen(false);
	setUiState({
		[indexName]: {
			menu: {
				[attribute]: [value],
			}
		}
	});
}

export const getUiState = () => router.read()[indexName] || {};


export const setUiState = newState => {
	search.setUiState(uiState => ({
		...uiState,
		[indexName]: {
			...uiState[indexName],
			page: 1,
			...newState,
		}
	}));
}

export const windowTitle = routeState => {
	if (!isSearchPage) {
		return null;
	}
	const indexState = routeState.indexName || {};
  	return indexState.query
		?  `${siteTitle} - Results for: ${indexState.s}`
	  : `${siteTitle} - Search Results`;
};
